// extracted by mini-css-extract-plugin
export default {"gallery_section_container":"Gallery_gallery_section_container__RNs3p","image_container":"Gallery_image_container__uOuNp"};